import { useTheme } from "@emotion/react";
import H2Style from "../../assets/themes/h2Style";

const Styles= (panelColor) => {
  const theme = useTheme();
  const h2Style = H2Style(theme)

  return {
    subtitle: { ...h2Style},
    card:{
        position:'relative', 
        width:'200px', 
        height:'100px',  
        border: `1px solid ${panelColor}` , 
        borderRadius:'5px',
         boxShadow: '10px 7px 10px 0px rgba(0, 0, 0, 0.36)'
    },
    icon:{
      position:'absolute', 
      height:'60px',
      width:'60px',
      top: '-8px',
      left: '5px',
      borderRadius:'5px', 
      display:'flex', 
      justifyContent:'center', 
      alignContent:'center', 
      alignItems:'center', 
    },
    centerArea:{
      display:'flex', 
      justifyContent:'end', 
      padding:'10px'
    },
    informationArea:{
      display:'flex', 
      flexDirection:'column',
      justifyContent:'center', 
      alignContent:'center', 
      alignItems:'center'
    },
    footerArea:{
      display:'flex',
      justifyContent:'center', 
      alignContent:'center', 
      alignItems:'center', 
    }

  }
}

export default Styles;
